import { render, staticRenderFns } from "./AdminCard.vue?vue&type=template&id=505b061a&scoped=true"
import script from "./AdminCard.vue?vue&type=script&lang=js"
export * from "./AdminCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "505b061a",
  null
  
)

export default component.exports